<template>
  <form
    :class="[
      isDarkMode || central_cloud ? 'text-white' : 'text-black',
      filter_disabled ? 'pointer-events-none' : '',
    ]"
    class="w-full"
    @submit.prevent="preventSubmit"
    @keyup.enter="submitFilterOptions"
  >
    <div
      class="bg-white rounded-xl lg:h-16 filter-wrapper mb-8 flex lg:items-center flex-wrap lg:flex-nowrap relative"
    >
      <div
        :class="author ? 'border-2 border-r-0 border-truegray-300' : ''"
        class="rounded-l-xl relative flex items-center lg:space-x-2 text-black flex-wrap lg:flex-nowrap w-full lg:w-auto"
      >
        <!-- keyword search -->
        <TextInput
          v-if="showFilterDD"
          :value="filterCloudBy.keywords"
          :label="'Searching for...'"
          :placeholder="'Enter Keywords'"
          :textarea="false"
          :placeholder_black="true"
          :fixed_width="true"
          :margin_bottom="false"
          :search_icon="true"
          :border_enabled="false"
          :response_selection_id="'filter_cloud_post_keywords'"
        />

        <!-- seperater && category -->
        <div
          v-if="settings.post_categories"
          class="w-px h-10 relative top-1 bg-truegray-300 hidden lg:block"
        ></div>
        <InputDropdown
          v-if="showFilterDD"
          :label="'Category'"
          :selected-options-initial="[categorySelected]"
          :placeholder-default="'Choose your category...'"
          :options="categories"
          :placeholder-black="true"
          :fixed-width="true"
          :text-xs="true"
          :margin-bottom="false"
          :border-enabled="false"
          :shadow-enabled="false"
          :cloud="true"
          :response-selection-id="'filter_cloud_post_categories'"
        />

        <div class="w-px h-10 relative top-1 bg-truegray-300 hidden lg:block" />
        <button
          class="bg-white h-10 flex items-center w-full lg:w-auto justify-center hover:text-cw-alt pl-4 pr-8 flex-shrink-0"
          @click="modalOpen = !modalOpen"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-4 w-4 mr-2 flex-shrink-0"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              d="M5 4a1 1 0 00-2 0v7.268a2 2 0 000 3.464V16a1 1 0 102 0v-1.268a2 2 0 000-3.464V4zM11 4a1 1 0 10-2 0v1.268a2 2 0 000 3.464V16a1 1 0 102 0V8.732a2 2 0 000-3.464V4zM16 3a1 1 0 011 1v7.268a2 2 0 010 3.464V16a1 1 0 11-2 0v-1.268a2 2 0 010-3.464V4a1 1 0 011-1z"
            />
          </svg>
          Filters
          <div
            v-if="filtersCount"
            :style="[{ fontSize: '0.5rem' }]"
            class="ml-2 rounded-full bg-cw-alt text-white font-bold h-4 w-4 flex items-center justify-center"
          >
            {{ filtersCount }}
          </div>
        </button>
      </div>

      <!-- Search button -->
      <button
        class="btn relative w-full lg:w-40 p-0 m-0 ml-auto font-primary"
        :disabled="thinking"
        :class="[
          thinking ? 'bg-cw-alt cursor-not-allowed' : 'btn-cw-alt',
          customisation && isDarkMode ? 'lg:h-full' : '',
          central_cloud ? 'lg:h-full ' : '',
          author ? 'h-12' : 'h-full',
        ]"
        @click="submitFilterOptions"
      >
        <div
          class="absolute inset-0 w-full flex justify-center items-center z-20"
        >
          <lottie v-if="thinking" :options="loadingAnimationOptions" />
        </div>
        <span :class="[thinking ? 'invisible' : '']">Search</span>
      </button>

      <!-- Modal -->
      <div
        :class="
          modalOpen
            ? 'transition-all duration-300 ease-in-out'
            : 'h-0 opacity-0 pointer-events-none'
        "
        class="filterModal absolute left-0 bg-white rounded-xl shadow-xl border border-truegray-300 p-6 z-20 text-black"
      >
        <div class="flex justify-between mb-8 items-center w-full">
          <h3 class="mb-0">Filters</h3>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-5 w-5 text-truegray-500 hover:text-cw-alt cursor-pointer transform hover:rotate-180 transition-all duration-300 ease-in-out"
            viewBox="0 0 20 20"
            fill="currentColor"
            @click="modalOpen = !modalOpen"
          >
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"
            />
          </svg>
        </div>

        <!-- Filters -->
        <div class="flex flex-col space-y-2 w-full">
          <!-- Filter match selector -->
          <div
            class="w-full flex flex-row justify-between items-center pb-4 mb-2 border-b border-truegray-300"
          >
            <span class="text-sm"> Show posts matching: </span>
            <FormulateInput
              v-model="filtersMatchAll"
              name="filtersMatchAll"
              type="select"
              :options="filtersMatchAllOptions"
            />
          </div>

          <!-- Category tags -->
          <!--
            <InputDropdownExpanding
            v-if="showFilterDD"
            :label="'Category'"
            :options="categories"
            :response_selection_id="'filter_cloud_post_categories'"
            :cloud="true"
            :multiselect="false"
            /> 
          -->

          <!-- Region tags -->
          <InputDropdownExpanding
            v-if="showFilterDD"
            :label="'Region'"
            :options="settings.tag_regions"
            :response-selection-id="'filter_cloud_tag_regions'"
            :is-cloud="true"
            :multiselect="false"
          />

          <!-- Year tags -->
          <InputDropdownExpanding
            v-if="showFilterDD"
            :label="'Related years'"
            :options="settings.tag_years"
            :response-selection-id="'filter_cloud_tag_years'"
            :is-cloud="true"
          />

          <!-- General tags -->
          <InputDropdownExpanding
            v-if="showFilterDD && settings.tags"
            :label="'General tags'"
            :options="settings.tags"
            :response-selection-id="'filter_cloud_post_tags'"
            :is-cloud="true"
          />

          <!-- Industry tags -->
          <InputDropdownExpanding
            v-if="showFilterDD && settings.tag_industries"
            :label="'Industry tags'"
            :options="settings.tag_industries"
            :response-selection-id="'filter_cloud_tag_industries'"
            :is-cloud="true"
            :flex="false"
          />

          <!-- Events old posts toggle -->
          <div
            v-if="filterCloudBy.category === 3"
            class="flex pl-2 my-2 w-full justify-between items-center space-x-2 text-sm pt-2"
          >
            <span v-if="filterCloudBy.old_events"
              >Show finished/expired events</span
            >
            <span v-if="!filterCloudBy.old_events"
              >Hide finished/expired events</span
            >
            <button
              type="button"
              class="relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none"
              :class="[filterCloudBy.old_events ? 'bg-cw-alt' : 'bg-gray-200']"
              role="switch"
              aria-checked="false"
              @click="toggleOldEvents"
            >
              <span
                aria-hidden="true"
                class="translate-x-0 pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"
                :class="[
                  filterCloudBy.old_events ? 'translate-x-5' : 'translate-x-0',
                ]"
              />
            </button>
          </div>

          <!-- Order by toggle -->
          <div
            v-if="filterCloudBy.category === 3"
            class="flex pl-2 my-2 w-full justify-between items-center space-x-2 text-sm"
          >
            <span v-if="filterCloudBy.order_events_by_publish_date"
              >Order by publish date</span
            >
            <span v-if="!filterCloudBy.order_events_by_publish_date"
              >Order by event date</span
            >
            <button
              type="button"
              class="relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none"
              :class="[
                filterCloudBy.order_events_by_publish_date
                  ? 'bg-cw-alt'
                  : 'bg-gray-200',
              ]"
              role="switch"
              aria-checked="false"
              @click="toggleOrderBy"
            >
              <span
                aria-hidden="true"
                class="translate-x-0 pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"
                :class="[
                  filterCloudBy.order_events_by_publish_date
                    ? 'translate-x-5'
                    : 'translate-x-0',
                ]"
              />
            </button>
          </div>
        </div>

        <div class="flex justify-between mt-4 items-end w-full">
          <p class="text-red-500 cursor-pointer" @click="resetFilters">
            Clear Filters
          </p>
          <button class="btn btn-black m-0" @click="modalOpen = !modalOpen">
            Save Filters
          </button>
        </div>
      </div>
    </div>

    <div class="w-full flex justify-start space-x-4 items-center text-white">
      <button
        :class="[
          resetFiltersDisabled
            ? 'opacity-25 cursor-not-allowed'
            : 'cursor-pointer',
        ]"
        :disabled="resetFiltersDisabled"
        type="button"
        class="flex items-center cursor-pointer group"
        @click="resetFilters"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-6 w-6 mr-2 transform group-hover:rotate-90 transition-all duration-300 ease-in-out"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
          />
        </svg>
        <span>Clear filters</span>
      </button>
    </div>
  </form>
</template>

<script>
import { EventBus } from '../../../js/plugins/event-bus.js'
import InputDropdown from '../../../shared/components/InputDropdown.vue'
import InputDropdownExpanding from '../../../shared/components/InputDropdownExpanding.vue'
import TextInput from '../../../shared/components/InputText.vue'
import { mapGetters, mapActions } from 'vuex'
import * as loadingAnimation from '../../../shared/components/loading.json'

export default {
  components: {
    InputDropdown,
    InputDropdownExpanding,
    TextInput,
  },

  props: {
    parent: { default: false },
    central_cloud: { default: false },
    author: { default: false },
  },

  data() {
    return {
      loadingAnimationOptions: { animationData: loadingAnimation.default },
      thinking: false,
      filterCategory: null,
      filterYear: null,
      filterRegion: null,
      filterTag: null,
      filterKeywords: null,
      filtersMatchAll: 1,
      showFilterDD: true,
      saved_posts: false,
      resetFiltersDisabled: true,
      categories: [],
      modalOpen: false,
      filter_disabled: false,
      categorySelected: null,
    }
  },

  computed: {
    // Set all map getters
    ...mapGetters({
      settings: 'shared/getSettings',
      customisation: 'careerwise/getCustomisation',
      isDarkMode: 'careerwise/isDarkMode',
      filterCloudBy: 'careerwise/getFilterCloudBy',
      filtersCount: 'careerwise/getFilterCloudByCount',
      filtersMatchAllOptions: 'shared/getFiltersMatchAllOptions',
    }),
  },

  watch: {
    filtersCount: {
      handler: function (value) {
        this.$set(this, 'resetFiltersDisabled', !value)
      },
    },

    filtersMatchAll: {
      handler: function () {
        this.dispatchSetFilterCloudBy({
          matchAll: !parseInt(this.filtersMatchAll),
        })
      },
    },

    saved_posts: {
      handler: function (val) {
        if (val) {
          this.dispatchSetFilterCloudBy({ draft: 1 })
        } else {
          this.dispatchSetFilterCloudBy({ draft: null })
        }
      },

      deep: true,
    },
  },

  mounted() {
    this.dispatchSetFilterCloudBy({ resetAll: true })

    this.$set(this, 'categories', this.settings.post_categories)
    for (let i = 0; i < this.categories.length; i++) {
      if (this.categories[i].value < 1) {
        this.categories.splice(i, 1)
        break
      }
    }

    EventBus.$on('filter_cloud_post_categories', (option) => {
      if (option === 99) {
        this.dispatchSetFilterCloudBy({ showAllPosts: true })
      } else {
        this.dispatchSetFilterCloudBy({ category: option })
      }

      this.$set(this, 'categorySelected', option)
    })

    EventBus.$on('filter_cloud_tag_years', (option) => {
      this.dispatchSetFilterCloudBy({ year: option })
    })

    EventBus.$on('filter_cloud_tag_regions', (option) => {
      this.dispatchSetFilterCloudBy({ region: option })
    })

    EventBus.$on('filter_cloud_post_tags', (option) => {
      this.dispatchSetFilterCloudBy({ tag: option })
    })

    EventBus.$on('filter_cloud_tag_industries', (option) => {
      this.dispatchSetFilterCloudBy({ industry: option })
    })

    EventBus.$on('filter_cloud_post_keywords', (option) => {
      this.dispatchSetFilterCloudBy({ keywords: option })
    })

    EventBus.$on('filter_posts_search_response_completed', () => {
      this.$set(this, 'thinking', false)
      this.$set(this, 'filter_disabled', false)
    })

    EventBus.$on('cloudpost_api_request_sent', () => {
      this.$set(this, 'filter_disabled', true)
    })

    this.$set(this, 'showFilterDD', true)
  },

  methods: {
    ...mapActions({
      dispatchSetFilterCloudBy: 'careerwise/dispatchSetFilterCloudBy',
    }),

    preventSubmit(e) {
      e.preventDefault()
    },

    resetFilters() {
      this.$set(this, 'saved_posts', false)
      this.$set(this, 'showFilterDD', false)
      this.$set(this, 'filtersMatchAll', 0)

      setTimeout(() => {
        this.$set(this, 'showFilterDD', true)
      }, 1)

      this.dispatchSetFilterCloudBy({ reset: true })
      // this.submitFilterOptions();
    },

    submitFilterOptions() {
      this.$set(this, 'thinking', true)
      EventBus.$emit('closeFilterDropdowns')
      EventBus.$emit('getCloudPostsWithFilterOptions', { parent: this.parent })
    },

    toggleOldEvents() {
      let active = !this.filterCloudBy.old_events
      this.dispatchSetFilterCloudBy({ old_events: active })
    },

    toggleOrderBy() {
      let active = !this.filterCloudBy.order_events_by_publish_date
      this.dispatchSetFilterCloudBy({ order_events_by_publish_date: active })
    },
  },
}
</script>

<style scoped>
.filterModal {
  width: 90%;
  margin-left: 5%;
}
@media screen and (min-width: 1024px) {
  .filter-wrapper {
    width: max-content;
  }
}

@media screen and (min-width: 800px) {
  .filterModal {
    top: 120%;
    width: 35rem;
    margin: 0;
  }
}
</style>
